import { ENVIRONMENT_NAME } from '@/configs/environment';

export const isStaging = (): boolean => {
  return process.env.NAME === ENVIRONMENT_NAME.STAGING;
};
